import { darken, mix, rgba } from 'polished';

import { interpolateRecord } from '@/utils/theme/utils';

export const base = {
  black: '#01011b',
  white: '#ffffff',
  obsidian: '#14141C',
  roseQuartz: '#F5C0C0',
  amethyst: '#A477B2',
  jade: '#5CB198',
  citrine: '#CDA849',
  opal: '#FBF9F9',
  violetTopaz: '#5F509D',
  cement: '#717A94'
};

export type BaseFgShades = {
  '100': number;
  '1000': number;
  '1100': number;
  '1200': number;
  '200': number;
  '300': number;
  '400': number;
  '500': number;
  '600': number;
  '700': number;
  '800': number;
  '900': number;
};

export const fgShades: BaseFgShades = {
  '100': 0,
  '200': 0.026,
  '300': 0.056,
  '400': 0.077,
  '500': 0.103,
  '600': 0.129,
  '700': 0.172,
  '800': 0.249,
  '900': 0.386,
  '1000': 0.446,
  '1100': 0.592,
  '1200': 0.923
};

export type BaseGridShades = {
  '1200': number;
  '200': number;
  '300': number;
  '400': number;
  '500': number;
  '600': number;
  '700': number;
};

export const gridShades: BaseGridShades = {
  '200': 0.077,
  '300': 0.103,
  '400': 0.129,
  '500': 0.172,
  '600': 0.249,
  '700': 0.386,
  '1200': 0.923
};

export type BgShades = {
  '300': number;
  '400': number;
  '500': number;
};

export const bgShades: BgShades = {
  '300': 0.025,
  '400': 0.0125,
  '500': 0
};

const fg = interpolateRecord(fgShades, 'fg', v =>
  mix(v, base.roseQuartz, base.obsidian)
);

const fgA = interpolateRecord(fgShades, 'fgA', v => rgba(base.roseQuartz, v));

const grid = interpolateRecord(gridShades, 'grid', v =>
  mix(v, base.roseQuartz, base.obsidian)
);

export const bg = interpolateRecord(bgShades, 'bg', v =>
  darken(v, base.obsidian)
);

export const palette = {
  ...base,
  ...fg,
  ...fgA,
  ...grid,
  ...bg,
  fgLoud: base.white
};

export type PaletteShape = typeof palette;
